import { IconType } from 'core/components/icons/types'
import React, { useRef } from 'react'
import cn from 'utils/cn'
import { useSettings } from 'core/hooks/settings/useSettings'

import ArrowLeft from './svg/arrow-left.svg?react'
import NewArrowLeft from './svg/new/arrow-left.svg?react'
import ArrowRight from './svg/arrow-right.svg?react'
import NewArrowRight from './svg/new/arrow-right.svg?react'
import ArrowUp from './svg/arrow-up.svg?react'
import NewArrowUp from './svg/new/arrow-up.svg?react'
import NewArrowDown from './svg/new/arrow-down.svg?react'
import Briefcase from './svg/briefcase.svg?react'
import NewBriefcase from './svg/new/briefcase.svg?react'
import BriefcaseOutline from './svg/briefcase-outline.svg?react'
import NewBriefcaseOutline from './svg/new/briefcase-outline.svg?react'
import CalculateRoute from './svg/calculate-route.svg?react'
import NewCalculateRoute from './svg/new/calculate-route.svg?react'
import Calendar from './svg/calendar.svg?react'
import NewCalendar from './svg/new/calendar.svg?react'
import CalendarOutline from './svg/calendar-outline.svg?react'
import NewCalendarOutline from './svg/new/calendar-outline.svg?react'
import Car from './svg/car.svg?react'
import NewCar from './svg/new/car.svg?react'
import CarOutline from './svg/car-outline.svg?react'
import NewCarOutline from './svg/new/car-outline.svg?react'
import Cards from './svg/cards.svg?react'
import NewCards from './svg/new/cards.svg?react'
import CardsOutline from './svg/cards-outline.svg?react'
import NewCardsOutline from './svg/new/cards-outline.svg?react'
import Categories from './svg/categories.svg?react'
import NewCategories from './svg/new/categories.svg?react'
import CategoriesOutline from './svg/categories-outline.svg?react'
import NewCategoriesOutline from './svg/new/categories-outline.svg?react'
import Check from './svg/check.svg?react'
import NewCheck from './svg/new/check.svg?react'
import CheckCircle from './svg/check-circle.svg?react'
import NewCheckCircle from './svg/new/check-circle.svg?react'
import CheckCircleOutline from './svg/check-circle-outline.svg?react'
import NewCheckCircleOutline from './svg/new/check-circle-outline.svg?react'
import ChevronDown from './svg/down.svg?react'
import NewChevronDown from './svg/new/chevron-down.svg?react'
import ChevronLeft from './svg/left.svg?react'
import NewChevronLeft from './svg/new/chevron-left.svg?react'
import ChevronRight from './svg/right.svg?react'
import NewChevronRight from './svg/new/chevron-right.svg?react'
import ChevronUp from './svg/up.svg?react'
import NewChevronUp from './svg/new/chevron-up.svg?react'
import Clipboard from './svg/clipboard.svg?react'
import NewClipboard from './svg/new/clipboard.svg?react'
import ClipboardOutline from './svg/clipboard-outline.svg?react'
import NewClipboardOutline from './svg/new/clipboard-outline.svg?react'
import Clock from './svg/clock.svg?react'
import NewClock from './svg/new/clock.svg?react'
import ClockOutline from './svg/clock-outline.svg?react'
import NewClockOutline from './svg/new/clock-outline.svg?react'
import Close from './svg/close.svg?react'
import NewClose from './svg/new/close.svg?react'
import CloseCircle from './svg/close-circle.svg?react'
import NewCloseCircle from './svg/new/close-circle.svg?react'
import CloseCircleOutline from './svg/close-circle-outline.svg?react'
import NewCloseCircleOutline from './svg/new/close-circle-outline.svg?react'
import Coins from './svg/coins.svg?react'
import NewCoins from './svg/new/coins.svg?react'
import NewCoinsOutline from './svg/new/coins-outline.svg?react'
import Deactivated from './svg/deactivated.svg?react'
import NewDeactivated from './svg/new/deactivated.svg?react'
import NewDeactivatedOutline from './svg/new/deactivated-outline.svg?react'
import DollarSign from './svg/dollar-sign.svg?react'
import NewDollarSign from './svg/new/dollar-sign.svg?react'
import DoubleArrowLeft from './svg/double-arrow-left.svg?react'
import NewDoubleArrowLeft from './svg/new/double-arrow-left.svg?react'
import DoubleArrowRight from './svg/double-arrow-right.svg?react'
import NewDoubleArrowRight from './svg/new/double-arrow-right.svg?react'
import Download from './svg/download.svg?react'
import NewDownload from './svg/new/download.svg?react'
import NewDownloadOutline from './svg/new/download-outline.svg?react'
import DownloadExcel from './svg/download-excel.svg?react'
import NewDownloadExcel from './svg/new/download-excel.svg?react'
import DownloadExcelOutline from './svg/download-excel-outline.svg?react'
import NewDownloadExcelOutline from './svg/new/download-excel-outline.svg?react'
import DownloadPdf from './svg/download-pdf.svg?react'
import NewDownloadPdf from './svg/new/download-pdf.svg?react'
import DownloadPdfOutline from './svg/download-pdf-outline.svg?react'
import NewDownloadPdfOutline from './svg/new/download-pdf-outline.svg?react'
import EditCircle from './svg/edit-circle.svg?react'
import NewEditCircle from './svg/new/edit-circle.svg?react'
import NewEditCircleOutline from './svg/new/edit-circle-outline.svg?react'
import Edit from './svg/edit.svg?react'
import NewEdit from './svg/new/edit.svg?react'
import NewEditOutline from './svg/new/edit-outline.svg?react'
import ExclamationMark from './svg/exclamation-mark.svg?react'
import NewExclamationMark from './svg/new/exclamation-mark.svg?react'
import Expand from './svg/expand.svg?react'
import NewExpand from './svg/new/expand.svg?react'
import Expense from './svg/expense.svg?react'
import NewExpense from './svg/new/expense.svg?react'
import NewExpenseOutline from './svg/new/expense-outline.svg?react'
import EyeClosed from './svg/eye-closed.svg?react'
import NewEyeClosed from './svg/new/eye-closed.svg?react'
import NewEyeClosedOutline from './svg/new/eye-closed-outline.svg?react'
import EyeOpen from './svg/eye-open.svg?react'
import NewEyeOpened from './svg/new/eye-opened.svg?react'
import NewEyeOpenedOutline from './svg/new/eye-opened-outline.svg?react'
import FavoritePlace from './svg/favorite-place.svg?react'
import NewFavoritePlace from './svg/new/favorite-place.svg?react'
import FavoritePlaceOutline from './svg/favorite-place-outline.svg?react'
import NewFavoritePlaceOutline from './svg/new/favorite-place-outline.svg?react'
import Filter from './svg/filter.svg?react'
import NewFilter from './svg/new/filter.svg?react'
import FilterOutline from './svg/filter-outline.svg?react'
import NewFilterOutline from './svg/new/filter-outline.svg?react'
import Flag from './svg/flag.svg?react'
import NewFlag from './svg/new/flag.svg?react'
import FlagOutline from './svg/flag-outline.svg?react'
import NewFlagOutline from './svg/new/flag-outline.svg?react'
import Gear from './svg/gear.svg?react'
import NewGear from './svg/new/gear.svg?react'
import GearOutline from './svg/gear-outline.svg?react'
import NewGearOutline from './svg/new/gear-outline.svg?react'
import GPSOutline from './svg/gps-outline.svg?react'
import Grip from './svg/grip.svg?react'
import NewGrip from './svg/new/grip.svg?react'
import NewGripOutline from './svg/new/grip-outline.svg?react'
import Heart from './svg/heart.svg?react'
import NewHeart from './svg/new/heart.svg?react'
import NewHeartOutline from './svg/new/heart-outline.svg?react'
import Help from './svg/help.svg?react'
import NewHelp from './svg/new/help.svg?react'
import HelpOutline from './svg/help-outline.svg?react'
import NewHelpOutline from './svg/new/help-outline.svg?react'
import Home from './svg/home.svg?react'
import NewHome from './svg/new/home.svg?react'
import HomeOutline from './svg/home-outline.svg?react'
import NewHomeOutline from './svg/new/home-outline.svg?react'
import Info from './svg/info.svg?react'
import NewInfo from './svg/new/info.svg?react'
import NewInfoOutline from './svg/new/info-outline.svg?react'
import Integrations from './svg/integrations.svg?react'
import NewIntegrations from './svg/new/integrations.svg?react'
import IntegrationsOutline from './svg/integrations-outline.svg?react'
import NewIntegrationsOutline from './svg/new/integrations-outline.svg?react'
import Key from './svg/key.svg?react'
import NewKey from './svg/new/key.svg?react'
import KeyOutline from './svg/key-outline.svg?react'
import NewKeyOutline from './svg/new/key-outline.svg?react'
import LightBulb from './svg/light-bulb.svg?react'
import NewLightBulb from './svg/new/light-bulb.svg?react'
import NewLightBulbOutline from './svg/new/light-bulb-outline.svg?react'
import Link from './svg/link.svg?react'
import NewLink from './svg/new/link.svg?react'
import Loading from './svg/loading.svg?react'
import NewLoading from './svg/new/loading.svg?react'
import Lock from './svg/lock.svg?react'
import NewLock from './svg/new/lock.svg?react'
import LockOutline from './svg/lock-outline.svg?react'
import NewLockOutline from './svg/new/lock-outline.svg?react'
import LogoutOutline from './svg/logout-outline.svg?react'
import NewLogoutOutline from './svg/new/logout.svg?react'
import Map from './svg/map.svg?react'
import NewMap from './svg/new/map.svg?react'
import MapOutline from './svg/map-outline.svg?react'
import NewMapOutline from './svg/new/map-outline.svg?react'
import Marker from './svg/marker.svg?react'
import NewMarker from './svg/new/marker.svg?react'
import MarkerOutline from './svg/marker-outline.svg?react'
import NewMarkerOutline from './svg/new/marker-outline.svg?react'
import Minus from './svg/minus.svg?react'
import NewMinus from './svg/new/minus.svg?react'
import MoreHorizontal from './svg/more-horizontal.svg?react'
import NewMoreHorizontal from './svg/new/more-horizontal.svg?react'
import MoreVertical from './svg/more-vertical.svg?react'
import NewMoreVertical from './svg/new/more-vertical.svg?react'
import Note from './svg/note.svg?react'
import NewNote from './svg/new/note.svg?react'
import NoteOutline from './svg/note-outline.svg?react'
import NewNoteOutline from './svg/new/note-outline.svg?react'
import Open from './svg/open.svg?react'
import NewOpen from './svg/new/open.svg?react'
import Person from './svg/person.svg?react'
import NewPerson from './svg/new/person.svg?react'
import PersonOutline from './svg/person-outline.svg?react'
import NewPersonOutline from './svg/new/person-outline.svg?react'
import NewPersonCheck from './svg/new/person-check.svg?react'
import PersonCheckOutline from './svg/person-check-outline.svg?react'
import NewPersonCheckOutline from './svg/new/person-check-outline.svg?react'
import PersonCircle from './svg/person-circle.svg?react'
import NewPersonCircle from './svg/new/person-circle.svg?react'
import PersonCircleOutline from './svg/person-circle-outline.svg?react'
import NewPersonCircleOutline from './svg/new/person-circle-outline.svg?react'
import Photo from './svg/photo.svg?react'
import NewPhoto from './svg/new/photo.svg?react'
import PhotoOutline from './svg/photo-outline.svg?react'
import NewPhotoOutline from './svg/new/photo-outline.svg?react'
import PinAndPen from './svg/pin-and-pen.svg?react'
import NewPinAndPen from './svg/new/pin-and-pen.svg?react'
import PinAndPenOutline from './svg/pin-and-pen-outline.svg?react'
import NewPinAndPenOutline from './svg/new/pin-and-pen-outline.svg?react'
import Play from './svg/play.svg?react'
import NewPlay from './svg/new/play.svg?react'
import Plus from './svg/plus.svg?react'
import NewPlus from './svg/new/plus.svg?react'
import Premium from './svg/premium.svg?react'
import NewPremium from './svg/new/premium.svg?react'
import Question from './svg/question.svg?react'
import NewQuestion from './svg/new/question.svg?react'
import Reimbursement from './svg/reimbursement.svg?react'
import NewReimbursement from './svg/new/reimbursement.svg?react'
import ReimbursementOutline from './svg/reimbursement-outline.svg?react'
import NewReimbursementOutline from './svg/new/reimbursement-outline.svg?react'
import Report from './svg/report.svg?react'
import NewReport from './svg/new/report.svg?react'
import ReportOutline from './svg/report-outline.svg?react'
import NewReportOutline from './svg/new/report-outline.svg?react'
import RoundTrip from './svg/round-trip.svg?react'
import NewRoundTrip from './svg/new/round-trip.svg?react'
import Rules from './svg/rules.svg?react'
import NewRules from './svg/new/rules.svg?react'
import RulesOutline from './svg/rules-outline.svg?react'
import NewRulesOutline from './svg/new/rules-outline.svg?react'
import Schedule from './svg/schedule.svg?react'
import NewSchedule from './svg/new/schedule.svg?react'
import ScheduleOutline from './svg/schedule-outline.svg?react'
import NewScheduleOutline from './svg/new/schedule-outline.svg?react'
import Search from './svg/search.svg?react'
import NewSearch from './svg/new/search.svg?react'
import SearchEmpty from './svg/search-empty.svg?react'
import NewSearchEmpty from './svg/new/search-empty.svg?react'
import Share from './svg/share.svg?react'
import NewShare from './svg/new/share.svg?react'
import SheetsOutline from './svg/sheets-outline.svg?react'
import NewSheetsOutline from './svg/new/sheets-outline.svg?react'
import Shop from './svg/shop.svg?react'
import NewShop from './svg/new/shop.svg?react'
import ShopOutline from './svg/shop-outline.svg?react'
import NewShopOutline from './svg/new/shop-outline.svg?react'
import Sort from './svg/sort.svg?react'
import NewSort from './svg/new/sort.svg?react'
import Star from './svg/star.svg?react'
import NewStar from './svg/new/star.svg?react'
import StartOutline from './svg/star-outline.svg?react'
import NewStartOutline from './svg/new/star-outline.svg?react'
import SteeringWheel from './svg/steering-wheel.svg?react'
import NewSteeringWheel from './svg/new/steering-wheel.svg?react'
import Summary from './svg/summary.svg?react'
import NewSummary from './svg/new/summary.svg?react'
import SummaryOutline from './svg/summary-outline.svg?react'
import NewSummaryOutline from './svg/new/summary-outline.svg?react'
import Synced from './svg/synced.svg?react'
import NewSynced from './svg/new/synced.svg?react'
import Tag from './svg/tag.svg?react'
import NewTag from './svg/new/tag.svg?react'
import TagOutline from './svg/tag-outline.svg?react'
import NewTagOutline from './svg/new/tag-outline.svg?react'
import Tax from './svg/tax.svg?react'
import NewTax from './svg/new/tax.svg?react'
import TaxOutline from './svg/tax-outline.svg?react'
import NewTaxOutline from './svg/new/tax-outline.svg?react'
import Team from './svg/team.svg?react'
import NewTeam from './svg/new/team.svg?react'
import TeamOutline from './svg/team-outline.svg?react'
import NewTeamOutline from './svg/new/team-outline.svg?react'
import Tracker from './svg/tracker.svg?react'
import NewTracker from './svg/new/tracker.svg?react'
import TrackerOutline from './svg/tracker-outline.svg?react'
import NewTrackerOutline from './svg/new/tracker-outline.svg?react'
import Transaction from './svg/transaction.svg?react'
import NewTransaction from './svg/new/transaction.svg?react'
import TransactionOutline from './svg/transaction-outline.svg?react'
import NewTransactionOutline from './svg/new/transaction-outline.svg?react'
import Trash from './svg/trash.svg?react'
import NewTrash from './svg/new/trash.svg?react'
import TrashOutline from './svg/trash-outline.svg?react'
import NewTrashOutline from './svg/new/trash-outline.svg?react'
import Trip from './svg/trip.svg?react'
import NewTrip from './svg/new/trip.svg?react'
import TripOutline from './svg/trip-outline.svg?react'
import NewTripOutline from './svg/new/trip-outline.svg?react'
import Upload from './svg/upload.svg?react'
import NewUpload from './svg/new/upload.svg?react'
import UploadCsv from './svg/upload-csv.svg?react'
import NewUploadCsv from './svg/new/upload-csv.svg?react'
import UploadCsvOutline from './svg/upload-csv-outline.svg?react'
import NewUploadCsvOutline from './svg/new/upload-csv-outline.svg?react'
import UploadOutline from './svg/upload-outline.svg?react'
import NewUploadOutline from './svg/new/upload-outline.svg?react'
import Vehicle from './svg/vehicle.svg?react'
import NewVehicle from './svg/new/vehicle.svg?react'
import VehicleOutline from './svg/vehicle-outline.svg?react'
import NewVehicleOutline from './svg/new/vehicle-outline.svg?react'
import Wallet from './svg/wallet.svg?react'
import NewWallet from './svg/new/wallet.svg?react'
import WalletOutline from './svg/wallet-outline.svg?react'
import NewWalletOutline from './svg/new/wallet-outline.svg?react'
import WalletWithBill from './svg/wallet-with-bill-.svg?react'
import NewWalletWithBill from './svg/new/wallet-with-bill.svg?react'
import WalletWithBillOutline from './svg/wallet-with-bill-outline.svg?react'
import NewWalletWithBillOutline from './svg/new/wallet-with-bill-outline.svg?react'
import Work from './svg/work.svg?react'
import NewWork from './svg/new/work.svg?react'
import WorkOutline from './svg/work-outline.svg?react'
import NewWorkOutline from './svg/new/work-outline.svg?react'

type IconsRecord = Record<
  IconType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
>

const Icons: IconsRecord = {
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowUp,
  briefcase: Briefcase,
  'briefcase-outline': BriefcaseOutline,
  'calculate-route': CalculateRoute,
  calendar: Calendar,
  'calendar-outline': CalendarOutline,
  car: Car,
  'car-outline': CarOutline,
  cards: Cards,
  'cards-outline': CardsOutline,
  categories: Categories,
  'categories-outline': CategoriesOutline,
  check: Check,
  'check-circle': CheckCircle,
  'check-circle-outline': CheckCircleOutline,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  clipboard: Clipboard,
  'clipboard-outline': ClipboardOutline,
  clock: Clock,
  'clock-outline': ClockOutline,
  close: Close,
  'close-circle': CloseCircle,
  'close-circle-outline': CloseCircleOutline,
  coins: Coins,
  'coins-outline': Coins,
  deactivated: Deactivated,
  'deactivated-outline': Deactivated,
  'dollar-sign': DollarSign,
  'double-arrow-left': DoubleArrowLeft,
  'double-arrow-right': DoubleArrowRight,
  download: Download,
  'download-outline': Download,
  'download-excel': DownloadExcel,
  'download-excel-outline': DownloadExcelOutline,
  'download-pdf': DownloadPdf,
  'download-pdf-outline': DownloadPdfOutline,
  edit: Edit,
  'edit-outline': Edit,
  'edit-circle': EditCircle,
  'edit-circle-outline': EditCircle,
  'exclamation-mark': ExclamationMark,
  expand: Expand,
  expense: Expense,
  'expense-outline': Expense,
  'eye-closed': EyeClosed,
  'eye-closed-outline': EyeClosed,
  'eye-open': EyeOpen,
  'eye-open-outline': EyeOpen,
  'favorite-place': FavoritePlace,
  'favorite-place-outline': FavoritePlaceOutline,
  filter: Filter,
  'filter-outline': FilterOutline,
  flag: Flag,
  'flag-outline': FlagOutline,
  gear: Gear,
  'gear-outline': GearOutline,
  'gps-outline': GPSOutline,
  grip: Grip,
  'grip-outline': Grip,
  heart: Heart,
  'heart-outline': Heart,
  help: Help,
  'help-outline': HelpOutline,
  home: Home,
  'home-outline': HomeOutline,
  info: Info,
  'info-outline': Info,
  integrations: Integrations,
  'integrations-outline': IntegrationsOutline,
  key: Key,
  'key-outline': KeyOutline,
  'light-bulb': LightBulb,
  'light-bulb-outline': LightBulb,
  link: Link,
  loading: Loading,
  lock: Lock,
  'lock-outline': LockOutline,
  'logout-outline': LogoutOutline,
  map: Map,
  'map-outline': MapOutline,
  marker: Marker,
  'marker-outline': MarkerOutline,
  minus: Minus,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  note: Note,
  'note-outline': NoteOutline,
  open: Open,
  person: Person,
  'person-check': PersonCheckOutline,
  'person-check-outline': PersonCheckOutline,
  'person-circle': PersonCircle,
  'person-circle-outline': PersonCircleOutline,
  'person-outline': PersonOutline,
  photo: Photo,
  'photo-outline': PhotoOutline,
  'pin-and-pen': PinAndPen,
  'pin-and-pen-outline': PinAndPenOutline,
  play: Play,
  plus: Plus,
  premium: Premium,
  question: Question,
  reimbursement: Reimbursement,
  'reimbursement-outline': ReimbursementOutline,
  report: Report,
  'report-outline': ReportOutline,
  'round-trip': RoundTrip,
  rules: Rules,
  'rules-outline': RulesOutline,
  schedule: Schedule,
  'schedule-outline': ScheduleOutline,
  search: Search,
  'search-empty': SearchEmpty,
  share: Share,
  'sheets-outline': SheetsOutline,
  shop: Shop,
  'shop-outline': ShopOutline,
  sort: Sort,
  star: Star,
  'star-outline': StartOutline,
  'steering-wheel': SteeringWheel,
  summary: Summary,
  'summary-outline': SummaryOutline,
  synced: Synced,
  tag: Tag,
  'tag-outline': TagOutline,
  tax: Tax,
  'tax-outline': TaxOutline,
  team: Team,
  'team-outline': TeamOutline,
  tracker: Tracker,
  'tracker-outline': TrackerOutline,
  transaction: Transaction,
  'transaction-outline': TransactionOutline,
  trash: Trash,
  'trash-outline': TrashOutline,
  trip: Trip,
  'trip-outline': TripOutline,
  upload: Upload,
  'upload-csv': UploadCsv,
  'upload-csv-outline': UploadCsvOutline,
  'upload-outline': UploadOutline,
  vehicle: Vehicle,
  'vehicle-outline': VehicleOutline,
  wallet: Wallet,
  'wallet-outline': WalletOutline,
  'wallet-with-bill': WalletWithBill,
  'wallet-with-bill-outline': WalletWithBillOutline,
  work: Work,
  'work-outline': WorkOutline
}

const GreenIcons: IconsRecord = {
  'arrow-down': NewArrowDown,
  'arrow-left': NewArrowLeft,
  'arrow-right': NewArrowRight,
  'arrow-up': NewArrowUp,
  briefcase: NewBriefcase,
  'briefcase-outline': NewBriefcaseOutline,
  'calculate-route': NewCalculateRoute,
  calendar: NewCalendar,
  'calendar-outline': NewCalendarOutline,
  car: NewCar,
  'car-outline': NewCarOutline,
  cards: NewCards,
  'cards-outline': NewCardsOutline,
  categories: NewCategories,
  'categories-outline': NewCategoriesOutline,
  check: NewCheck,
  'check-circle': NewCheckCircle,
  'check-circle-outline': NewCheckCircleOutline,
  'chevron-down': NewChevronDown,
  'chevron-left': NewChevronLeft,
  'chevron-right': NewChevronRight,
  'chevron-up': NewChevronUp,
  clipboard: NewClipboard,
  'clipboard-outline': NewClipboardOutline,
  clock: NewClock,
  'clock-outline': NewClockOutline,
  close: NewClose,
  'close-circle': NewCloseCircle,
  'close-circle-outline': NewCloseCircleOutline,
  coins: NewCoins,
  'coins-outline': NewCoinsOutline,
  deactivated: NewDeactivated,
  'deactivated-outline': NewDeactivatedOutline,
  'dollar-sign': NewDollarSign,
  'double-arrow-left': NewDoubleArrowLeft,
  'double-arrow-right': NewDoubleArrowRight,
  download: NewDownload,
  'download-outline': NewDownloadOutline,
  'download-excel': NewDownloadExcel,
  'download-excel-outline': NewDownloadExcelOutline,
  'download-pdf': NewDownloadPdf,
  'download-pdf-outline': NewDownloadPdfOutline,
  edit: NewEdit,
  'edit-outline': NewEditOutline,
  'edit-circle': NewEditCircle,
  'edit-circle-outline': NewEditCircleOutline,
  'exclamation-mark': NewExclamationMark,
  expand: NewExpand,
  expense: NewExpense,
  'expense-outline': NewExpenseOutline,
  'eye-closed': NewEyeClosed,
  'eye-closed-outline': NewEyeClosedOutline,
  'eye-open': NewEyeOpened,
  'eye-open-outline': NewEyeOpenedOutline,
  'favorite-place': NewFavoritePlace,
  'favorite-place-outline': NewFavoritePlaceOutline,
  filter: NewFilter,
  'filter-outline': NewFilterOutline,
  flag: NewFlag,
  'flag-outline': NewFlagOutline,
  gear: NewGear,
  'gear-outline': NewGearOutline,
  'gps-outline': GPSOutline,
  grip: NewGrip,
  'grip-outline': NewGripOutline,
  heart: NewHeart,
  'heart-outline': NewHeartOutline,
  help: NewHelp,
  'help-outline': NewHelpOutline,
  home: NewHome,
  'home-outline': NewHomeOutline,
  info: NewInfo,
  'info-outline': NewInfoOutline,
  integrations: NewIntegrations,
  'integrations-outline': NewIntegrationsOutline,
  key: NewKey,
  'key-outline': NewKeyOutline,
  'light-bulb': NewLightBulb,
  'light-bulb-outline': NewLightBulbOutline,
  link: NewLink,
  loading: NewLoading,
  lock: NewLock,
  'lock-outline': NewLockOutline,
  'logout-outline': NewLogoutOutline,
  map: NewMap,
  'map-outline': NewMapOutline,
  marker: NewMarker,
  'marker-outline': NewMarkerOutline,
  minus: NewMinus,
  'more-horizontal': NewMoreHorizontal,
  'more-vertical': NewMoreVertical,
  note: NewNote,
  'note-outline': NewNoteOutline,
  open: NewOpen,
  person: NewPerson,
  'person-outline': NewPersonOutline,
  'person-check': NewPersonCheck,
  'person-check-outline': NewPersonCheckOutline,
  'person-circle': NewPersonCircle,
  'person-circle-outline': NewPersonCircleOutline,
  photo: NewPhoto,
  'photo-outline': NewPhotoOutline,
  'pin-and-pen': NewPinAndPen,
  'pin-and-pen-outline': NewPinAndPenOutline,
  play: NewPlay,
  plus: NewPlus,
  premium: NewPremium,
  question: NewQuestion,
  reimbursement: NewReimbursement,
  'reimbursement-outline': NewReimbursementOutline,
  report: NewReport,
  'report-outline': NewReportOutline,
  'round-trip': NewRoundTrip,
  rules: NewRules,
  'rules-outline': NewRulesOutline,
  schedule: NewSchedule,
  'schedule-outline': NewScheduleOutline,
  search: NewSearch,
  'search-empty': NewSearchEmpty,
  share: NewShare,
  'sheets-outline': NewSheetsOutline,
  shop: NewShop,
  'shop-outline': NewShopOutline,
  sort: NewSort,
  star: NewStar,
  'star-outline': NewStartOutline,
  'steering-wheel': NewSteeringWheel,
  summary: NewSummary,
  'summary-outline': NewSummaryOutline,
  synced: NewSynced,
  tag: NewTag,
  'tag-outline': NewTagOutline,
  tax: NewTax,
  'tax-outline': NewTaxOutline,
  team: NewTeam,
  'team-outline': NewTeamOutline,
  tracker: NewTracker,
  'tracker-outline': NewTrackerOutline,
  transaction: NewTransaction,
  'transaction-outline': NewTransactionOutline,
  trash: NewTrash,
  'trash-outline': NewTrashOutline,
  trip: NewTrip,
  'trip-outline': NewTripOutline,
  upload: NewUpload,
  'upload-outline': NewUploadOutline,
  'upload-csv': NewUploadCsv,
  'upload-csv-outline': NewUploadCsvOutline,
  vehicle: NewVehicle,
  'vehicle-outline': NewVehicleOutline,
  wallet: NewWallet,
  'wallet-outline': NewWalletOutline,
  'wallet-with-bill': NewWalletWithBill,
  'wallet-with-bill-outline': NewWalletWithBillOutline,
  work: NewWork,
  'work-outline': NewWorkOutline
}

interface IconProps {
  /**
   * Name of the icon to render.
   */
  name: `${IconType}`
  /**
   * Width of the icon (overrides default SVG width).
   */
  width?: string | number
  /**
   * Height of the icon (overrides default SVG height).
   */
  height?: string | number
  /**
   * Size of the icon (overrides both width and height).
   */
  size?: string | number
  /**
   * Additional class names for the icon container.
   */
  className?: string
  /**
   * ID for the icon element or wrapper.
   */
  id?: string
  /**
   * Color class for the icon (e.g., 'text-primary').
   */
  color?: string
  /**
   * Click event handler for the icon.
   */
  onClick?: React.MouseEventHandler<SVGSVGElement>
  /**
   * Mouse down event handler for the icon.
   */
  onMouseDown?: React.MouseEventHandler<SVGSVGElement>
  /**
   * Optional title for accessibility.
   */
  title?: string
  /**
   * ARIA label for accessibility.
   */
  ariaLabel?: string
}

/**
 * Icon component for rendering SVG icons by name.
 * Supports custom sizing, color, wrapper, and event handlers.
 */
const Icon = ({
  name,
  height = 16,
  width = 16,
  size,
  className = '',
  id,
  color,
  onClick,
  onMouseDown,
  title,
  ariaLabel
}: IconProps) => {
  const {
    data: {
      featureFlags: { ENABLE_GREEN_APP }
    }
  } = useSettings()
  const svgRef = useRef<SVGSVGElement>(null)
  const Element = ENABLE_GREEN_APP ? GreenIcons[name] : Icons[name]

  const loadingStyle = name === 'loading' && 'animate-spin'

  // Graceful fallback for invalid icon names
  if (!Element) {
    console.warn(`Icon: Icon "${name}" not found`)
    return null
  }

  return (
    <Element
      height={size ?? height}
      width={size ?? width}
      id={id}
      className={cn(['transition-colors', color, className, loadingStyle])}
      ref={svgRef}
      onClick={onClick}
      onMouseDown={onMouseDown}
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      data-title={title}
    />
  )
}

export default Icon
